import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import {FaShoppingCart, FaTv} from 'react-icons/fa';
import Configuration from '../config';
import {subscriptionStatuses} from '../constants';
import {
  specialEventIsFree,
  specialEventPriceCents,
  specialEventSubscriptionStatus
} from '../util/special-event-access';

export const specialEventHomeCardContext = (event, partner, subscriptions, now = new Date()) => {
  const channel = partner && Array.isArray(partner.rtvChannels)
    ? partner.rtvChannels.find(candidate => Number(candidate.id) === Number(event && event.rtvChannelId))
    : null;
  const subscriptionStatus = specialEventSubscriptionStatus(subscriptions, event, now);
  const priceCents = specialEventPriceCents(event, channel);
  const canWatch = Boolean(channel) && (
    (Number(channel.type) === 0 && (
      subscriptionStatus.status === subscriptionStatuses.valid ||
      subscriptionStatus.status === subscriptionStatuses.unlimited ||
      specialEventIsFree(event, channel)
    )) ||
    (Number(channel.type) === 1 && subscriptionStatus.status === subscriptionStatuses.valid)
  );

  return {channel, subscriptionStatus, priceCents, canWatch};
};

const SpecialEventHomeCard = ({event, partner, subscriptions, locale, onAccess, t}) => {
  const context = specialEventHomeCardContext(event, partner, subscriptions);
  const price = (context.priceCents / 100).toFixed(2);
  const scheduled = context.subscriptionStatus.status === subscriptionStatuses.scheduledEvent;
  const actionLabel = context.canWatch
    ? t('WATCH_RTV')
    : scheduled
      ? t('HOME_REDESIGN_SPECIAL_EVENT_PURCHASED')
      : t('HOME_REDESIGN_SPECIAL_EVENT_BUY', {price});
  const action = () => onAccess(event, partner, context);

  return (
    <article className="home-redesign-rail-card home-redesign-rail-card--event">
      <button type="button" className="home-redesign-media" onClick={action}>
        <div
          className="home-redesign-media__image home-redesign-media__image--event"
          style={event.imageName && event.imageName.length > 0
            ? {backgroundImage: `url(${Configuration.apiEndPoint}/partners/events/${event.id}/images?load=${event.imageName[0]})`}
            : null}
        >
          <span className="home-redesign-badge home-redesign-badge--event">{t('SPECIAL_EVENTS')}</span>
          <span className="home-redesign-media__overlay-text">{event.title}</span>
        </div>
      </button>
      <div className="home-redesign-rail-card__body">
        <div className="home-redesign-rail-card__meta">
          <strong>{event.title}</strong>
          <span>{event.businessName}</span>
        </div>
        <div className="home-redesign-rail-card__details">
          <span>{event.city}</span>
          <span>{t('HOME_REDESIGN_SPECIAL_EVENT_ACCESS_RANGE', {
            start: new Date(event.startDatetime).toLocaleDateString(locale),
            end: new Date(event.endDatetime).toLocaleDateString(locale)
          })}</span>
          <span>{t('HOME_REDESIGN_SPECIAL_EVENT_CONTENT_RANGE', {
            start: new Date(event.contentStartDatetime || event.startDatetime).toLocaleDateString(locale),
            end: new Date(event.contentEndDatetime || event.endDatetime).toLocaleDateString(locale)
          })}</span>
          <strong>{t('HOME_REDESIGN_SPECIAL_EVENT_PRICE', {price})}</strong>
        </div>
        <div className="home-redesign-rail-card__actions">
          <Button
            type="button"
            className={`btn home-skywork-action ${context.canWatch ? 'home-skywork-action--secondary' : 'home-skywork-action--primary'}`}
            onClick={action}
          >
            {context.canWatch ? <FaTv aria-hidden="true"/> : <FaShoppingCart aria-hidden="true"/>}
            {actionLabel}
          </Button>
        </div>
      </div>
    </article>
  );
};

SpecialEventHomeCard.propTypes = {
  event: PropTypes.object.isRequired,
  partner: PropTypes.object,
  subscriptions: PropTypes.object,
  locale: PropTypes.string.isRequired,
  onAccess: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

SpecialEventHomeCard.defaultProps = {
  partner: null,
  subscriptions: null
};

export default SpecialEventHomeCard;
